import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';

import { STRIPE_API_VERSION } from '../../../utils/constants';
import FormCard from './FormCard';

const REACT_APP_STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromiseState = loadStripe(REACT_APP_STRIPE_PUBLISHABLE_KEY, {
  locale: 'en',
  apiVersion: STRIPE_API_VERSION,
});

export default function ElementCard(props) {
  return (
    <Elements stripe={stripePromiseState}>
      <FormCard
        errorMessage={props.errorMessage}
        dataCard={props.dataCard}
        cardData={props.cardData}
        someEmptyElement={props.someEmptyElement}
        style={props.style}
        setLoadingStripeToken={props.setLoadingStripeToken}
        onCardReady={props.onCardReady}
      />
    </Elements>
  );
}
